module.exports = __webpack_public_path__ + "static/media/openMsg.267ac295.svg";